import React, { memo } from "react";

interface EntityBrandProps {
  logo?: string;
  name?: string;
  fallbackName?: string;
}

const EntityBrand: React.FC<EntityBrandProps> = memo(
  ({ logo, name, fallbackName }) => {
    if (logo) {
      return (
        <div className="w-12 h-12 rounded-xl overflow-hidden border border-white/40 shadow-sm bg-white">
          <img
            src={logo}
            alt={name}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
      );
    }

    const initial =
      (name || fallbackName || "?").trim().charAt(0).toUpperCase() || "?";

    return (
      <div className="w-12 h-12 rounded-xl border border-white/40 bg-white/10 flex items-center justify-center text-lg font-semibold text-white shadow-sm">
        {initial}
      </div>
    );
  }
);

EntityBrand.displayName = "EntityBrand";

export default EntityBrand;
